<!--(selected)="onSelect()"-->
<div *ngIf="!isMobile" ngbTooltip="{{toolTip}}" container="body" placement="top" style="display: flex; flex-direction: column; align-items: center;">
	<i [class]="'territoryCardIcon ' + fontAwesomeIconClass"></i>
	<div class="territoryCardActionBarText">{{iconLabel}}</div>
</div>
<!--display action icon like "more" item-->
<div *ngIf="isMobile" role="button" class="territoryCardBackOfCardContainer">
	<div class="territoryCardIconBackOfCard">
		<i [class]="'territoryCardIcon ' + fontAwesomeIconClass"></i>
	</div>
	<div class="territoryCardBackOfCardItemText">{{iconLabel}}</div>
</div>
